import React, { useEffect, useMemo, useState } from 'react';
import './Loader.scss';

const Loader = ({
  text = 'Loading...',
  title = '',
  subtitle = '',
  badge = '',
  tips = [],
}) => {
  const tipItems = useMemo(() => tips.filter(Boolean), [tips]);
  const [currentTipIndex, setCurrentTipIndex] = useState(0);

  useEffect(() => {
    setCurrentTipIndex(0);
  }, [tipItems.length, text, title, subtitle, badge]);

  useEffect(() => {
    if (tipItems.length <= 1) return undefined;

    const intervalId = setInterval(() => {
      setCurrentTipIndex((prev) => (prev + 1) % tipItems.length);
    }, 3200);

    return () => clearInterval(intervalId);
  }, [tipItems]);

  const activeTip = tipItems[currentTipIndex];

  return (
    <div className="loader-container">
      <div className="loader-panel" role="status" aria-live="polite">
        {badge ? <div className="loader-badge">{badge}</div> : null}
        <div className="loader" />
        <div className="loader-copy">
          <h3 className="loader-title">{title || text}</h3>
          <p className="loader-text">{text}</p>
          {subtitle ? <p className="loader-subtitle">{subtitle}</p> : null}
        </div>

        {activeTip ? (
          <div className="loader-tip-card">
            <span className="loader-tip-card__label">Quick Tip</span>
            <p className="loader-tip-card__text">{activeTip}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Loader;
